import { type ComponentChildren, createContext } from 'preact';
import { useContext, useEffect, useMemo } from 'preact/hooks';

interface Props {
  readonly title?: null | string | readonly (string | undefined | null)[];
  readonly children?: ComponentChildren;
}

const PageTitleContext = createContext('');

export const PageTitle = ({ title, children }: Props) => {
  const outerTitle = useContext(PageTitleContext);
  const combinedTitle = useMemo(() => {
    return [outerTitle, ...(isTitleArray(title) ? title : [title])]
      .map((value) => value?.trim())
      .filter(Boolean)
      .join(' / ');
  }, [outerTitle, title]);

  useEffect(() => {
    if (!title) return;
    document.title = combinedTitle;
    return () => (document.title = outerTitle);
  }, [combinedTitle, outerTitle]);

  return <PageTitleContext.Provider value={combinedTitle}>{children}</PageTitleContext.Provider>;
};

function isTitleArray(title: Props['title']): title is readonly (string | undefined | null)[] {
  return Array.isArray(title);
}
